import _ from 'lodash';
import { PureComponent } from 'react';
import TableGrid from '../../views/TableGrid';
import { BadWeight, Duplicate, SoundsLike, Header, HeaderSub, Code, Text, CodeInline } from './../../views/typography';

export default (bottle) => {
  bottle.factory('VocabularyDrilldownAddHelp', () => {
    class VocabularyDrilldownAddHelp extends PureComponent {
      render() {
        return (
          <section>
            <Header>
              Help for adding Terms to A Vocabulary List
            </Header>
            <Text>
              A vocabulary is a group of words or phrases you expect to come up in sound files you want transcribed.
              It helps the audio parser detect unusual words or discriminate between words that sound similar to each
              other.
            </Text>
            <HeaderSub>Terms</HeaderSub>
            <Text>
              Each vocabulary has a
              {' '}
              <b>Name</b>
              {' '}
that you use when you include it for targeting, and a set of
              {' '}
              <b>Terms</b>
.
              A term can be one or many words or phrases (
              <CodeInline>coupon</CodeInline>
              {' '}
or
              {' '}
              <CodeInline>direct deposit</CodeInline>
).
              You can paste a list of terms from a CSV file or text editor, one per line as in:
              <div>
                <Code>coupon</Code>
              </div>
              <div>
                <Code>direct deposit</Code>
              </div>
              <div>
                <Code>Wildebeest</Code>
              </div>
            </Text>
            <Text>
              Each term has a
              {' '}
              <b>Weight</b>
              {' '}
which determines how aggressively the transcriber looks for and uses the term.
              Useful weights range from
              {' '}
              <b>0</b>
              {' '}
(less frequent replacement) to
              {' '}
              <b>3</b>
              {' '}
(very aggressive replacement).
              The entire vocabulary has a default weight that applies to all
              the terms in this group unless you override it.
              To set the individual weight for a term add a number after a comma:
              <div>
                <Code>coupon</Code>
              </div>
              <div>
                <Code>direct deposit</Code>
              </div>
              <div>
                <Code>Wildebeest,0</Code>
              </div>
              In this case,
              {' '}
              <CodeInline>coupon</CodeInline>
              {' '}
and
              {' '}
              <CodeInline>direct Deposit</CodeInline>
              receive the weight you choose from the weight slider, and
              {' '}
              <CodeInline>Wildebeest</CodeInline>
              gets assigned a weight of 0.
            </Text>
            <HeaderSub>SoundsLike</HeaderSub>
            <Text>
To help the parser determine what a term would sound like, you can add homonyms for that word
            with commas after the term. This is useful for company names that use differential spelling
            that doesn&apos;t come across when it is said aloud, like
              <CodeInline>VoiceBase, voice base</CodeInline>
            or
              {' '}
              <CodeInline>Blazinski, blaze in ski</CodeInline>
.
              <Header>The Preview</Header>
              After pasting a set of terms into the terms field you will get a grid preview of your pending vocabulary.
            </Text>
            <TableGrid style={({ width: '100%' })}>
              <thead>
                <tr>
                  <th style={({ minWidth: 80 })}>Term</th>
                  <th style={({ width: 50 })}>Weight</th>
                  <th>SoundsLike</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>coupon</td>
                  <td>1</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>direct deposit</td>
                  <td>1</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>Wildebeest</td>
                  <td>0</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>Blazinski</td>
                  <td>1</td>
                  <td><SoundsLike>blaze in ski</SoundsLike></td>
                </tr>
              </tbody>
            </TableGrid>
            <HeaderSub>Problem Highlighting</HeaderSub>
            <Text>
If you have duplicate terms or terms with radically large/small weights
              these will be highlighted as in
              {' '}
            </Text>
            <TableGrid style={({ width: '100%' })}>
              <thead>
                <tr>
                  <th style={({ minWidth: 80 })}>Term</th>
                  <th style={({ width: 50 })}>Weight</th>
                  <th>SoundsLike</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <Duplicate>coupon</Duplicate>
                  <td>1</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <Duplicate>coupon</Duplicate>
                  <td>2</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>direct deposit</td>
                  <td>1</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>Wildebeest</td>
                  <td>0</td>
                  <td><SoundsLike>&nbsp;</SoundsLike></td>
                </tr>
                <tr>
                  <td>Blazinski</td>
                  <BadWeight>100</BadWeight>
                  <td><SoundsLike>blaze in ski</SoundsLike></td>
                </tr>
              </tbody>
            </TableGrid>
            <Header>Correction</Header>
            <Text>
If for any reason you add bad data or want to update it, you can re-upload a vocabulary
            with the same name and it will replace the previous entry.
              {' '}
            </Text>

          </section>
        );
      }
    }

    return VocabularyDrilldownAddHelp;
  });
};

/*        <TableGrid style={({ width: '100%' })}>
            <thead>
              <tr>
                <th style={({ minWidth: 80 })}>Term</th>
                <th style={({ width: 50 })}>Weight</th>
                <th>SoundsLike</th>
              </tr>
            </thead>
            <tbody>
              {_.get(this, 'state.termsList', []).map((term => this.termRow(term)))}
            </tbody>
          </TableGrid> */
